module.exports = __webpack_public_path__ + "img/U_S_studies.c4dc2c41.svg";